import { Component, Input, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { Router, RouterModule } from '@angular/router';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { NgbDate, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../Model/utility/utility.service';
import moment from 'moment';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { AttendanceService } from '../Model/Attendance/attendance.service';
import { CalendarService } from '../Model/Calendar/calendar.service';
import { SessionService } from '../Util/Session/session.service';
import { LeaveService } from '../Model/Leave/leave.service';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';

@Component({
  selector: 'app-admin-attendance-view',
  standalone: true,
  imports: [LoaderComponent, FormsModule, CommonModule, NgSelectModule, NgbDatepickerModule, DataTablesModule, RouterModule],
  templateUrl: './admin-attendance-view.component.html',
  styleUrl: './admin-attendance-view.component.scss'
})
export class AdminAttendanceViewComponent {

  @Input() EmployeeId = 0;
  @Input() EmpType = '';
  @Input() EmpPhoto = '';
  @Input() EmpName = '';
  @Input() EmpDesignation = '';
  @Input() EmpCode = '';
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  isDisabled: boolean = false;
  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  TableDatas: any[] = [];
  Employees: any[] = [];
  calendarDataSummary: any[] = [];
  EmployeeLeave = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private toast: ToastService,
    private utility: UtilityService,
    protected dateFormat: CustomDateParserFormatter,
    private attendance: AttendanceService,
    private Calendar: CalendarService,
    private session: SessionService,
    private modalService: NgbModal,
    private leave: LeaveService,
    private tooltip: TooltipService,
  ) {
    // this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
    this.common.CompanyParameter();
    this.user = this.session.GetUserDetails();
    this.ToDayDate = this.dateFormat.parse(moment(Date()).format("DD MMM YYYY"));
    
  }

  search() {
    this.AttendanceDetail.EmpMasterId = this.EmployeeId;
    this.user.EmpType = this.EmpType;
    

    this.SelectDate('RegistrationDate', null, null);
  }

  user: any;
  Comment = '';
  Colour1 = '';
  Colour2 = '';

  ngOnInit() {
    this.AttendanceDetail.EmpMasterId = this.EmployeeId;
    this.user.EmpType = this.EmpType;
    this.CalendarDetailsData.Photo = this.EmpPhoto;
    this.CalendarDetailsData.EmployeeName = this.EmpName;
    this.CalendarDetailsData.EmpCode = this.EmpCode;
    this.CalendarDetailsData.DesignationName = this.EmpDesignation
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  calendarData: any[] = [];

  ShiftDetail = {
    ShiftFrom: '09:00:00 AM' as any,
    ShiftTo: '06:00:00 PM',
  };

  filter = {
    AttendanceDate: null as any
  }

  Duration: string = '0h 0m 0s';
  isShowAttendaceBtn: boolean = false;
  CurrentTime = null as any;
  IntervalId: any;
  ToDayDate = null as any;
  LateCheckInDuration: string = '0h 0m 0s';

  Filter = {
    Date: '' as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    EmpCode: '' as any,
    MonthName: null as any,
    EmployeeId: null as any,
    IsWithdraw: false,
    EmpType: 'FRONT',
    EmpPhoto: ''
  }

  AttendanceDetail = {
    EmpMasterId: null as any,
    EmployeeName: null,
    EmpType: null,
    DesignationID: null,
    DesignationName: null,
    DutyID: null,
    DutyName: null,
    BranchID: null,
    BranchName: null,
    SiteID: null,
    SiteName: null,
    ShiftMasterID: null,
    ShiftTitle: null,
    AttendanceDate: null as any,
    InTime: null as any,
    OutTime: null as any,
    WorkingHour: null,
    AttendanceStatus: null,
    AttendanceStatusOut: null,
    AttendanceRemark: null,
    AttendanceRemarkOut: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    OpenMonth: null,
    OpenYear: null,
    BiometricAttendanceId: null,
    IsManual: null,
    AttendanceMatchPercentage: null,
    Latitude: null,
    Longitude: null,
    Altitude: null,
    NearByLocationName: null,
    BillableOT: null,
    NonBillableOT: null,
    RegularizationID_IN: null,
    RegularizationID_OUT: null,
    LeaveID: null,
    AttendanceDescription: null,
    ApprovalStatus: null,
    GeoTagged: null,
    MobileName: null,
    AccessCard: null,
    MobileId: null,
    Address: null,
    Remark: null,
    NearByLocationName1: null,
    IsOtherDuty: null,
    WebCheckInOut: null,
    MobileCheckInOut: null,
    GeoTagging: null,
    SiteQRCodeScanning: null,
    EmployeeQRCodeScanning: null,
    Selfie: null,
    SelfieType: null,
    EmployeeNotCheckIn: null,
    IsOtherDuty1: null,
    IsAttendanceAll: null,
    RestrictIP: null,
    IP: null,
    AttendanceType: null,
    Duration: null,
    HalfDayDuration: null,
    OTApplicable: null,
    OTApplicableIn: null,
    FirstCheckInLate: null,
    LastCheckOutEarly: null,
    Deviation: null,
    DeviationMoreThan: null,
    DeviationMoreThanPeriod: null,
    DeviationOccurMultiplyOf: null,
    DeviationOccurMultiplyOFPeriod: null,
    LeaveDeductDay: null,
    LeaveDeductType: null,
    ShiftMargin: null,
    HourBeforeShiftStart: null,
    HourAfterShiftStart: null,
    Insentive: null,
    AttendanceGreaterThan: null,
    AttendanceOccurMultiplyOf: null,
    AttendanceOccurMultiplyOfPeriod: null,
    IsCheckIn: false,
    IsAttendaceClose: false,
    SelectType: 'InsertUpdate',
  };

  onnavigate(event: any) {
    this.Filter.MonthName = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'front',
      'EmpCode': this.Filter.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } else if (Combotype == 'EmpLoadForRegularization') {
            if (this.Filter.BranchId == null) {
              this.toast.show({ message: 'Kindly select atleast Branch', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            if (response.ComboLoad.length == 0) {
              this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            this.TableDatas = response.ComboLoad;
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDateTime(IsAction: boolean) {
    this.isDisabled = true;
    this.isShowAttendaceBtn = false;
    if (!this.AttendanceDetail.IsAttendaceClose || !IsAction) {
      this.utility.GetDateTime().subscribe({
        next: (response) => {
          if (IsAction && !this.AttendanceDetail.IsCheckIn) {
            this.AttendanceDetail.AttendanceDate = (moment(response.Current_Date).year() + '-' + (moment(response.Current_Date).month() + 1) + '-' + moment(response.Current_Date).date()).toString();
          } else {
            this.AttendanceDetail.AttendanceDate = (moment(this.AttendanceDetail.InTime).year() + '-' + (moment(this.AttendanceDetail.InTime).month() + 1) + '-' + moment(this.AttendanceDetail.InTime).date()).toString();
          }
          this.CurrentTime = moment(response.Current_Date);
          if (!this.AttendanceDetail.IsCheckIn && IsAction) {
            this.CheckIn();
          } else if (this.AttendanceDetail.IsCheckIn && IsAction) {
            this.CheckOut();
          } else if (this.AttendanceDetail.IsCheckIn && !IsAction) {
            this.CheckInStart(this.AttendanceDetail.InTime, true);
          } else {
            this.isShowAttendaceBtn = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: 'Attendace not allowed for today.', type: toastTypeEnum.danger });
    }
  }

  CheckIn() {
    //if (this.AttendanceDetail.WebCheckInOut) {
    if (!this.AttendanceDetail.IsCheckIn) {
      this.AttendanceDetail.IsCheckIn = true;
      this.AttendanceDetail.InTime = this.CurrentTime;
      this.getIPAddress()
    }
    // } else {
    //   this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
    // }
  }

  CheckOut() {
    if (this.AttendanceDetail.WebCheckInOut) {
      if (this.AttendanceDetail.IsCheckIn) {
        this.AttendanceDetail.IsCheckIn = false;
        clearInterval(this.IntervalId);
        this.IntervalId = null;
        this.AttendanceDetail.OutTime = this.CurrentTime;
        this.getIPAddress();
      }
    } else {
      this.toast.show({ message: "Web attendance not allowed", type: toastTypeEnum.danger });
    }
  }

  getIPAddress() {
    this.isDisabled = true;
    return this.utility.getIPAddress().subscribe({
      next: (response) => {
        this.AttendanceDetail.IP = response.ip;
        this.isDisabled = false;
      },
      complete: () => {
        this.AttendanceInOutSave();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  AttendanceInOutSave(): any {
    this.isDisabled = true;
    if (this.AttendanceDetail.IsCheckIn) {
      this.AttendanceDetail.InTime = this.AttendanceDetail.InTime._i.toString();
    } else if (!this.AttendanceDetail.IsCheckIn) {
      this.AttendanceDetail.OutTime = this.AttendanceDetail.OutTime._i.toString();
    }
    this.attendance.AttendanceInOutSave(this.AttendanceDetail).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          if (this.AttendanceDetail.IsCheckIn) {
            this.CheckInStart(this.CurrentTime, true);
          } else if (!this.AttendanceDetail.IsCheckIn) {
            this.AttendanceDetail.OutTime = this.CurrentTime;
          }
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          this.AttendanceDetail.AttendanceDate = null;
          this.AttendanceDetail.InTime = null;
          this.AttendanceDetail.OutTime = null;
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
        }
        this.SelectDate('RegistrationDate', null, null);
        this.isDisabled = false;
        return true;
      },
      complete: () => {
        //this.GetDailyAttendanceInOut();
        return true;
      },
      error: (error) => {
        this.isDisabled = false;
        return false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.ToDayDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
        }
        // this.LoadBirthdayDetails();

        this.GetCalendar(this.dateFormat.fullmonth[this.Filter.MonthName.month - 1], this.Filter.MonthName.year);
        this.ESS_GetESSAttendanceSummaryWeb(this.dateFormat.fullmonth[this.Filter.MonthName.month - 1], this.Filter.MonthName.year);
        this.isDisabled = false;
      },
      complete: () => {
        this.GetDailyAttendanceInOut();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CheckInStart(AttendanceDateTime: any, IsNewChekin: boolean) {
    this.ShiftDetail.ShiftFrom = moment(new Date(this.CurrentTime._i.split(' ')[0] + ' ' + this.ShiftDetail.ShiftFrom));
    this.AttendanceDetail.InTime = AttendanceDateTime;
    this.AttendanceDetail.OutTime = this.CurrentTime;
    if (this.AttendanceDetail.InTime > this.ShiftDetail.ShiftFrom) {
      this.LateCheckInDuration = this.calculateLate(this.AttendanceDetail.InTime, this.ShiftDetail.ShiftFrom);
    } else {
      this.LateCheckInDuration = '';
    }

    if (this.IntervalId != null) {
      clearInterval(this.IntervalId);
      this.IntervalId = null;
    }

    this.IntervalId = setInterval(() => {
      this.AttendanceDetail.OutTime = moment(this.AttendanceDetail.OutTime).add(moment.duration(1, 'second'));
      this.CalculateTimeDifference();
    }, 1000);

    this.isShowAttendaceBtn = true;
  }

  GetCalendar(Month: String, Year: String) {
    this.Calendar.GetAttendanceCalendar({ MonthName: Month, YearName: Year, EmpMasterId: this.EmployeeId, }).subscribe({
      next: (response) => {
        this.calendarData = response;
        if (this.filter.AttendanceDate == null) {
          this.filter.AttendanceDate = this.dateFormat.parse(moment(Date()).add({ day: -1 }).format("DD MMM YYYY"));
        }

        if (this.calendarData.filter(e => this.dateFormat.format(this.dateFormat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFormat.format(this.dateFormat.parse(moment(this.dateFormat.format(this.filter.AttendanceDate)).format("DD MMM YYYY")))).length > 0) {
          this.GetDailyAttendanceInOutDetail(this.calendarData.filter(e => this.dateFormat.format(this.dateFormat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFormat.format(this.dateFormat.parse(moment(this.dateFormat.format(this.filter.AttendanceDate)).format("DD MMM YYYY"))))[0].DailyAttendanceInOutID);
        } else {
          this.GetDailyAttendanceInOutDetail(0);
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ESS_GetESSAttendanceSummaryWeb(Month: String, Year: String) {
    this.calendarDataSummary = [];
    this.Calendar.ESS_GetESSAttendanceSummaryWeb({ MonthName: Month, YearName: Year, EmpMasterID: this.EmployeeId, }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.calendarDataSummary = response.Table;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  GetDailyAttendanceInOut() {
    this.isDisabled = true;
    this.attendance.GetDailyAttendanceInOut({ SelectType: 1, EmpMasterId: this.AttendanceDetail.EmpMasterId, MonthName: this.dateFormat.fullmonth[this.ToDayDate.month - 1], YearName: this.ToDayDate.year }).subscribe({
      next: (response) => {
        if (response.toString() != '') {
          this.AttendanceDetail = response[0];
          this.AttendanceDetail.SelectType = 'InsertUpdate';
          //this.AttendanceDetail.InTime = null;
          //this.AttendanceDetail.OutTime = null;
          if (moment(response[0].AttendanceDate).isSame(this.dateFormat.format(this.ToDayDate))) {
            if (response[0].InTime != null && response[0].OutTime == null) {
              this.AttendanceDetail.IsCheckIn = true;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.GetDateTime(false);
            } else if (response[0].InTime != null && response[0].OutTime != null) {
              this.AttendanceDetail.IsAttendaceClose = true;
              this.AttendanceDetail.IsCheckIn = false;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.AttendanceDetail.OutTime = moment(response[0].OutTime);
              this.CalculateTimeDifference();
              this.GetDateTime(false);
            } else {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.isShowAttendaceBtn = true;
            }
          } else {
            if (response[0].InTime != null && response[0].OutTime == null) {
              this.AttendanceDetail.IsCheckIn = true;
              this.AttendanceDetail.InTime = moment(response[0].InTime);
              this.GetDateTime(false);
            } else if (response[0].InTime != null && response[0].OutTime != null) {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.GetDateTime(false);
            } else {
              this.AttendanceDetail.InTime = null;
              this.AttendanceDetail.OutTime = null;
              this.isShowAttendaceBtn = true;
            }
          }
        } else {
          this.isShowAttendaceBtn = true;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CalculateTimeDifference() {
    const startTime = this.AttendanceDetail.InTime;
    const endTime = this.AttendanceDetail.OutTime;
    const diff = endTime - startTime;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    this.Duration = `${hours}h ${minutes}m ${seconds}s`;
  }

  calculateLate(actualTime: any, expectedTime: any): string {
    const diff = actualTime - expectedTime;
    if (diff > 0) {
      const hoursLate = Math.floor(diff / (1000 * 60 * 60)); // Convert milliseconds to hours
      const minutesLate = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)); // Convert remaining milliseconds to minutes
      const secondsLate = Math.floor((diff % (1000 * 60)) / 1000); // Convert remaining milliseconds to seconds

      return `${hoursLate} h ${minutesLate} m ${secondsLate} s`;
    } else {
      return 'On time';
    }
  }

  GetDailyAttendanceInOutDetail(id: number) {
    if (id > 0) {
      this.isDisabled = true;
      this.attendance.GetDailyAttendanceInOut({ DailyAttendanceInOutID: id, SelectType: 2, EmpMasterId: this.EmployeeId, FromDate: null, ToDate: null, ApprovalStatus: 'ALL' }).subscribe({
        next: (response) => {
          if (response.toString() != '') {
            this.CalendarDetailsData.id = id;
            this.CalendarDetailsData.Photo = response[0].Photo;
            this.CalendarDetailsData.EmployeeName = response[0].EmployeeName;
            this.CalendarDetailsData.EmpCode = response[0].EmpCode;
            this.CalendarDetailsData.DesignationName = response[0].DesignationName;
            this.CalendarDetailsData.AttendanceDate = (response[0].AttendanceDate != null && response[0].AttendanceDate != "") ? this.dateFormat.parse(response[0].AttendanceDate.split("-")[2] + " " + this.dateFormat.month[parseInt(response[0].AttendanceDate.split("-")[1]) - 1] + " " + response[0].AttendanceDate.split("-")[0]) : '';
            this.CalendarDetailsData.InTime = response[0].InTime;
            this.CalendarDetailsData.OutTime = response[0].OutTime;
            this.CalendarDetailsData.ShiftTitle = response[0].ShiftTitle;
            this.CalendarDetailsData.Remark = response[0].Remark;
            this.CalendarDetailsData.DailyAttendancePhoto = this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["DailyAttendancePhoto"];
            this.CalendarDetailsData.DailyAttendancePhotoOut = this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["DailyAttendancePhotoOut"];
            this.CalendarDetailsData.InReason = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["InReason"].split("-")[1] : "";
            this.CalendarDetailsData.OutReason = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["OutReason"].split("-")[1] : "";
            this.CalendarDetailsData.AttendanceDescription = (this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"] != null && this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"] != "") ? this.calendarData.filter(e => e.DailyAttendanceInOutID == id)[0]["AttendanceDescription"].split(':')[1] : '';
          } else {
            this.CalendarDetailsData.id = 0;
            this.CalendarDetailsData.Photo = this.EmpPhoto;
            this.CalendarDetailsData.EmployeeName = this.EmpName;
            this.CalendarDetailsData.EmpCode = null;
            this.CalendarDetailsData.DesignationName = this.EmpDesignation;
            this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
            this.CalendarDetailsData.InTime = null;
            this.CalendarDetailsData.OutTime = null;
            this.CalendarDetailsData.ShiftTitle = null;
            this.CalendarDetailsData.Remark = null;
            this.CalendarDetailsData.DailyAttendancePhoto = null;
            this.CalendarDetailsData.DailyAttendancePhotoOut = null;
            this.CalendarDetailsData.InReason = null;
            this.CalendarDetailsData.OutReason = null;
            this.CalendarDetailsData.AttendanceDescription = null;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.CalendarDetailsData.id = 0;
      this.CalendarDetailsData.Photo = this.EmpPhoto;
      this.CalendarDetailsData.EmployeeName = this.EmpName;
      this.CalendarDetailsData.EmpCode = null;
      this.CalendarDetailsData.DesignationName = this.EmpDesignation;
      this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
      this.CalendarDetailsData.InTime = null;
      this.CalendarDetailsData.OutTime = null;
      this.CalendarDetailsData.ShiftTitle = null;
      this.CalendarDetailsData.Remark = null;
      this.CalendarDetailsData.DailyAttendancePhoto = null;
      this.CalendarDetailsData.DailyAttendancePhotoOut = null;
      this.CalendarDetailsData.InReason = null;
      this.CalendarDetailsData.OutReason = null;
      this.CalendarDetailsData.AttendanceDescription = null;
    }
  }

  CalendarDetailsData = {
    id: 0,
    Photo: null as any,
    EmployeeName: '',
    EmpCode: null as any,
    DesignationName: null as any,
    AttendanceDate: null as any,
    InTime: null,
    OutTime: null,
    ShiftTitle: null,
    Remark: null,
    DailyAttendancePhoto: null,
    DailyAttendancePhotoOut: null,
    InReason: null,
    OutReason: null,
    AttendanceDescription: null,
    TotalTime: ''
  }

  CalenderDateSelect(event: any) {
    if (this.calendarData.filter(e => this.dateFormat.format(this.dateFormat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFormat.format(event)).length > 0) {
      this.GetDailyAttendanceInOutDetail(this.calendarData.filter(e => this.dateFormat.format(this.dateFormat.parse(moment(e.AttendanceDate).format("DD MMM YYYY"))) == this.dateFormat.format(event))[0].DailyAttendanceInOutID);
    } else {
      this.CalendarDetailsData.id = 0;
      this.CalendarDetailsData.Photo = this.EmpPhoto;
      this.CalendarDetailsData.EmployeeName = this.EmpName;
      this.CalendarDetailsData.EmpCode = null;
      this.CalendarDetailsData.DesignationName = this.EmpDesignation;
      this.CalendarDetailsData.AttendanceDate = this.filter.AttendanceDate;
      this.CalendarDetailsData.InTime = null;
      this.CalendarDetailsData.OutTime = null;
      this.CalendarDetailsData.ShiftTitle = null;
      this.CalendarDetailsData.Remark = null;
      this.CalendarDetailsData.DailyAttendancePhoto = null;
      this.CalendarDetailsData.DailyAttendancePhotoOut = null;
      this.CalendarDetailsData.InReason = null;
      this.CalendarDetailsData.OutReason = null;
      this.CalendarDetailsData.AttendanceDescription = null;
    }
  }

  getDayStyle(date: NgbDate): any {
    if (date.year === this.ToDayDate.year && date.month === this.ToDayDate.month && date.day === this.ToDayDate.day) {
      return {};
    } else if (date.year === this.filter.AttendanceDate.year && date.month === this.filter.AttendanceDate.month && date.day === this.filter.AttendanceDate.day) {
      return {
        'background-color': '#0078D4',
        'color': 'white',
        'border-radius': '.25rem'
      };
    }
    else {
      return {};
    }
  }

  getDayDotStyle(date: NgbDate): any {
    const currentDate = new Date(date.year, date.month - 1, date.day);
    const matchingEvent = this.calendarData.find(event =>
      new Date(event.AttendanceDate).toDateString() === currentDate.toDateString()
    );

    if (matchingEvent) {
      const baseColor = matchingEvent.Color;
      const backgroundColor = baseColor;
      // this.Colour1 = baseColor;

      return {
        'background-color': backgroundColor,
        // 'left': this.Colour2 == '' ? '50%' : '30%'
      };
    } else {
      return {};
    }
  }

  getDayDotStyle2(date: NgbDate): any {
    const currentDate = new Date(date.year, date.month - 1, date.day);
    const matchingEvent = this.calendarData.find(event =>
      new Date(event.AttendanceDate).toDateString() === currentDate.toDateString()
    );

    if (matchingEvent) {
      const baseColor = matchingEvent.ColorNew;
      const backgroundColor = baseColor;
      this.Colour2 = baseColor

      return {
        'background-color': backgroundColor,
      };
    } else {
      return {};
    }
  }

  calculateTotalDuration(startTime: any, endTime: any): string {
    if (startTime !== null && endTime !== null) {
      const [startHours, startMinutes, startSeconds] = startTime.split(':').map(Number);
      const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number);

      const now = new Date();

      const start = new Date(now);
      start.setHours(startHours, startMinutes, startSeconds, 0);

      const end = new Date(now);
      end.setHours(endHours, endMinutes, endSeconds, 0);

      // Handle next day case
      if (end < start) {
        end.setDate(end.getDate() + 1);
      }

      const diffMs = end.getTime() - start.getTime();
      const totalMinutes = Math.floor(diffMs / (1000 * 60));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      // Pad with zero if needed (e.g., "02:05")
      const formatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      return formatted;
    }
    return '';
  }

  onNavigate(event: any) {
    this.GetCalendar(this.dateFormat.fullmonth[event.next.month - 1], event.next.year);
    this.ESS_GetESSAttendanceSummaryWeb(this.dateFormat.fullmonth[event.next.month - 1], event.next.year);
  }

  async SaveEmployeeLeaveDetails(index: any) {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsView) {
        if (result) {
          this.isDisabled = true;
          this.leave.SaveEmployeeLeaveDetails({ SelectType: 'WITHDRAWN', ESS_EmployeeLeaveDetailsID: this.EmployeeLeave[index]['EmployeeLeaveDetailsID'] }).subscribe({
            next: (response) => {
              if (response.Error_Code == '404') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.GetEmployeeLeaveDetails();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }

  GetEmployeeLeaveDetails() {
    console.log(this.Filter.MonthName);
    const lastDay = new Date(this.Filter.MonthName.year, this.Filter.MonthName.month, 0);
    console.log(lastDay);
    this.AttendanceDetail.EmpMasterId = this.EmployeeId;
    this.isDisabled = true;
    this.leave.GetEmployeeLeaveDetails({ ESS_EmployeeLeaveDetailsID: 0, EmpMasterID: this.AttendanceDetail.EmpMasterId, FromDate: this.dateFormat.format(this.Filter.MonthName), ToDate: this.dateFormat.format(this.Filter.MonthName), ApprovalStatus: 'ALL', SelectType: 1 }).subscribe({
      next: (response) => {
        this.EmployeeLeave = response;
        this.dtElement?.dtInstance?.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });

  }
}
